import React, { Component } from 'react';

import Conteudo from './Conteudo';
import FormularioAcesso from './modules/auth/FormularioAcesso';
import Perfil from './Perfil';

export default class extends Component {
  render() {
    return (
      <div>
        <Conteudo>
          <Perfil />
          <br />
          Solicite acesso preenchendo os campos abaixo:
          <FormularioAcesso />
        </Conteudo>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NotAuthorized.js